module.exports = __webpack_public_path__ + "img/img_14@2x.dafba8c1.png";